/**
 * `MotionRoot` — mounted once, above the router.
 *
 * `reducedMotion="user"` makes every framer animation in the tree honour
 * `prefers-reduced-motion`: transforms and layout animations are skipped,
 * opacity crossfades are kept. That is the right split — a person who has
 * asked for less movement still needs to see that a dialog opened and a
 * step changed; they just should not watch it travel. The CSS side of the
 * same promise lives in src/index.css.
 */
import React from 'react';
import { MotionConfig, useReducedMotion } from 'framer-motion';

export const MotionRoot: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <MotionConfig reducedMotion="user">{children}</MotionConfig>;

/** `true` when the person has asked the OS for less motion. */
export const useReducedMotionPref = (): boolean => useReducedMotion() === true;
